/**
 * AES 256 CBC 알고리즘으로 문자열을 암호화하는 모듈
 *
 * @since 2018-09-20
 * @author ms1124.kim
 */

import crypto from 'crypto'
import {base64Encode} from './base64'

/*
  이름: encryptionPassword
  설명: 전달된 문자열을 AES 256 CBC로 암호화한다.
*/
function encryptionPassword (key, password, bs = 16) {
  // 키 또는 비밀번호가 올바른 값이 아닌 경우, 에러메세지를 브라우저 콘솔에 출력.
  if (!key || !password) {
    window.$nuxt.$log('[Login password encryption error] : The value for the key or password is empty.') // TAMS
    return false
  }

  // 알고리즘 선택
  const algo = 'aes-256-cbc'

  // iv값 생성
  const iv = crypto.randomBytes(bs)

  // 암호화 객체 생성
  const cipherObj = crypto.createCipheriv(algo, key.substring(0, 32), iv)

  // 비밀번호 암호화 수행
  let encrypted = cipherObj.update(password, 'utf-8')

  // 암호화 종료
  encrypted = Buffer.concat([encrypted, cipherObj.final()])

  // Base64로 인코딩된 IV + encrypted.
  return base64Encode(iv.toString('hex') + encrypted.toString('hex'))
}

// TAMS
function encryptionJsonString (key, plaintext, bs = 16) {
  try {
    // 키 또는 비밀번호가 올바른 값이 아닌 경우, 에러메세지를 브라우저 콘솔에 출력.
    if (!key || !plaintext) {
      return false
    }

    const encodetext = encodeURIComponent(plaintext)

    // 알고리즘 선택
    const algo = 'aes-256-cbc'

    // iv값 생성
    const iv = crypto.randomBytes(bs)

    // 암호화 객체 생성
    const cipherObj = crypto.createCipheriv(algo, key.substring(0, 32), iv)

    // 문자열 암호화 수행
    let encrypted = cipherObj.update(encodetext, 'utf-8')

    // 암호화 종료
    encrypted = Buffer.concat([encrypted, cipherObj.final()])

    // Base64로 인코딩된 IV + encrypted.
    return base64Encode(iv.toString('hex') + encrypted.toString('hex'))
  } catch (e) {
    window.$nuxt.$log('Crypto Helper GUI Error (encryptionJsonString)', e)
  }
}

function sha1 (str) {
  return crypto
    .createHash('sha1')
    .update(str)
    .digest('hex')
}

export {
  encryptionPassword,
  encryptionJsonString,
  sha1
}
